<template>
    <div>

        <i>
            Nesta tela você informará a quantidade de pais que a sua instituição conseguirá atender na confirmação da matrícula para os alunos
            que realizarão a pré-matrícula online. 
        </i>

        <el-form @submit.native.prevent="onSubmitPreMatriculaAgenda" ref="dados" label-position="top">

            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                    <el-select @change="loadingAgenda()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição">
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>DATA</th>
                        <th>QTD MATUTINO</th>
                        <th>QTD VESPERTINO</th>
                        <th>QTD NOTURNO</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in dados.datas" :key="i">
                        <td>
                            <el-date-picker 
                                disabled
                                class="date-picker-matricula"
                                v-model="dados.datas[i].data" 
                                type="date"                                  
                                format="dd/MM/yyyy" 
                                value-format="yyyy-MM-dd"
                                style="width: 100%;"
                            ></el-date-picker>
                        </td>
                        <td style="width: 200px;">
                            <b class="hidden-desktop">QTD MATUTINO:</b>
                            <el-input v-model="dados.datas[i].vagas_totais_matutino" maxlength="191"></el-input>
                        </td>
                        <td style="width: 200px;">
                            <b class="hidden-desktop">QTD VESPERTINO:</b>
                            <el-input v-model="dados.datas[i].vagas_totais_vespertino" maxlength="191"></el-input>
                        </td>
                        <td style="width: 200px;">
                            <b class="hidden-desktop">QTD NOTURNO:</b>
                            <el-input v-model="dados.datas[i].vagas_totais_noturno" maxlength="191"></el-input>
                        </td>
                    </tr>
                </tbody>
            </table>
          
            <el-row :gutter="10" v-if="filtro.instituicao_id">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" id="btn-modelo" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        alert: false,
        filtro: {
            instituicao_id: '',
        },
        dados: {             
            datas: []
        }

    }),
    mounted () {

        if(this.$store.state.config.instituicao){ 
        
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id; 
            this.loadingAgenda();
        }

    },
    methods:{
        loadingAgenda(){

            if(!this.filtro.instituicao_id){
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getAgendaByInstituicao/${this.filtro.instituicao_id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });

            
        },
        onSubmitPreMatriculaAgenda(){

            window.eventBus.$emit('loading', true);   
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/updateAgenda/${this.filtro.instituicao_id}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                
                this.loadingAgenda();
                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
           
        }        
    }
}
</script>
